// Store
import { useTemplateStore } from "@/zustand/templateStore";

interface CardButtonProps {
  loading?: boolean;
  processingLabel?: string;
}

const CardButton: React.FC<CardButtonProps> = ({
  loading = false,
  processingLabel,
}) => {
  const { form } = useTemplateStore();

  return (
    <button
      type="submit"
      disabled={loading}
      className={`border-cc-blue-2 bg-cc-blue font-poppins w-full cursor-pointer rounded-md border-b-2 px-6 py-[18px] text-lg font-bold text-white shadow-[0_1px_1px_rgba(0,0,0,0.25)] ${
        loading ? "cursor-not-allowed opacity-70" : ""
      }`}
    >
      <span>
        {loading
          ? processingLabel || form?.tr_processing_label
          : form?.tr_order_now_label}
      </span>
    </button>
  );
};

export default CardButton;
